import React, { useState, useEffect } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import FormSection from '../../../components/atom/FormSection';
import { doSwaggerCall } from '../../../hooks/useSwaggerClient';

import EmaillogTable from '../../admin/emaillogs/EmaillogTable';

const BookingItemEmails = ({ bookingItemId }) => {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [data, setData] = useState({ logs: [], count: 0 });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!bookingItemId) {
            return;
        }

        setLoading(true);
        setError(null);

        doSwaggerCall('emaillogs', 'getEmaillogsPerBookingItem', {
            page,
            pageSize,
            bookingItemId
        })
            .then(data => {
                setData(data || { logs: [], count: 0 });
            })
            .catch(err => {
                setError(err?.response?.body?.message || 'Failed to load emails');
            })
            .finally(() => {
                setLoading(false);
            });
    }, [bookingItemId, page, pageSize]);

    if (loading && !data?.logs?.length) {
        return (
            <FormSection title="Booking emails">
                <Grid container justifyContent="center" style={{ padding: 20 }}>
                    <CircularProgress size={24} />
                </Grid>
            </FormSection>
        );
    }

    if (error) {
        return (
            <FormSection title="Booking emails">
                <Alert severity="error">{error}</Alert>
            </FormSection>
        );
    }

    return (
        <FormSection title="Booking emails">
            <Grid item container xs={12} justifyContent="center">
                <EmaillogTable
                    total={data?.count}
                    emails={data?.logs}
                    page={page}
                    pageSize={pageSize}
                    setPage={setPage}
                    setPageSize={setPageSize}
                />
            </Grid>
        </FormSection>
    );
};

export default BookingItemEmails;
